/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import { PermissionLevel, ServicePermissions } from 'components/Project/types/enums';
import { User } from 'store/user/types';
import { ServiceCode } from 'store/user/types/service';

export function isServiceEnabledInProd(
  user: User,
  serviceCode: ServiceCode | ServiceCode[],
): boolean {
  if (user.isTest) {
    return true;
  }

  if (Array.isArray(serviceCode)) {
    const services = user.services.filter((_service) => serviceCode.includes(_service.code));
    if (services.length === 0) {
      return false;
    }
    if (services.some((_service) => _service.isDebugMode === false)) {
      return true;
    }
    return false;
  }
  const service = user.services.find((_service) => _service.code === serviceCode);

  if (!service) {
    return false;
  }
  if (service.isDebugMode === false) {
    return true;
  }
  return false;
}

export const hasAnyServicePermission = (permissions:Partial<Record<ServicePermissions, PermissionLevel>>, servicesToCheck:ServicePermissions[]) => {
  if (!permissions) return false;

  return servicesToCheck.some((service) => permissions[service]);
};
